import styles from "./Grid.module.css";

export const Grid = ({
  elements,
  style,
  columns = 2,
}: {
  elements: React.ReactNode[],
  style?: React.CSSProperties
  columns?: number,
}) => {
  return (
    <div 
      className={styles.grid} 
      style={{
        ...(style ?? {}),
        ["--grid-columns" as any]: columns,
      }}
    >
      {elements.map((el, index) => (
        <div key={index}>
          {el}
        </div>
      ))}
    </div>
  );
};